import React from "react";
import "../../styles/Language.css";
import Header from "../../ReUseAbleComp/Header.jsx";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Units = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <Helmet>
        <title>Pashto Units</title>
      </Helmet>
      <div className="bg-image"></div>
      <Header
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
      <div className="mix_title">
        <h1 className="mix_title_text">
          Creating awareness for strengthening Local
          Governance
          <br />
          <span className="mix_title_text_urdu">
            اگاہی براے مستحکم مقامی نظام
          </span>
        </h1>
      </div>

      <div className="lang_langSelect">
        <Link to="/LGPashto" className="res-circle">
          <div className="circle-txt">محلي حکومت</div>
        </Link>
        <Link
          to="/CovidPashtoTopics"
          className="res-circle"
        >
          <div className="circle-txt">کرونا وایرس</div>
        </Link>
        <a href="" className="res-circle">
          <div className="circle-txt">جنرال</div>
        </a>
      </div>
    </>
  );
};

export default Units;
